import * as SessionStorage from "@omni/utils/sessionStorage.utils";

import { StorageKeys } from "@/utils/enums";

type SoftLoginDetails = {
    email: string | null;
    firstName: string | null;
    lastName: string | null;
};

export const clearSoftLogin = () => {
    SessionStorage.removeItem(StorageKeys.CustomerEmail);
    SessionStorage.removeItem(StorageKeys.CustomerFirstName);
    SessionStorage.removeItem(StorageKeys.CustomerLastName);
};

export const setSoftLogin = (email: string, firstName?: string) => {
    if (firstName) {
        SessionStorage.setItem(StorageKeys.CustomerFirstName, firstName);
    }
    SessionStorage.setItem(StorageKeys.CustomerEmail, email);
};

export const getSoftLoginDetails = (): SoftLoginDetails => {
    return {
        email: SessionStorage.getItem(StorageKeys.CustomerEmail),
        firstName: SessionStorage.getItem(StorageKeys.CustomerFirstName),
        lastName: SessionStorage.getItem(StorageKeys.CustomerLastName)
    };
};

export const isSoftLoggedIn = () => {
    return !!getSoftLoginDetails().email;
};
